<mat-card class="search mat-elevation-z3">
    <mat-card-title class="title">
      Digite o nome de um Animalzinho <i class="material-icons"> favorite </i>
    </mat-card-title>
    <input class="pesquisa" placeholder="Escreva aqui" />
  </mat-card>
  <div class="fotoAnimal">
    <ul class="lista">
      <li nome="cachorro">
        <img src="./../../../../assets/animais genericos/cachorro.jpg" /> Cachorro
      </li>
      <li nome="cavalo">
        <img src="./../../../../assets/animais genericos/cavalo.jpg" /> Cavalo
      </li>
      <li nome="coelho">
        <img src="./../../../../assets/animais genericos/coelho.jpg" /> Coelho
      </li>
      <li nome="gato">
        <img src="./../../../../assets/animais genericos/gato.jpg" /> Gato
      </li>
      <li nome="passaro">
        <img src="./../../../../assets/animais genericos/passaro.jpg" /> Pássaro
      </li>
      <li nome="peixe">
        <img src="./../../../../assets/animais genericos/peixe.jpg" /> Peixe
      </li>
      <li nome="tigre">
        <img src="./../../../../assets/animais genericos/tigre.jpg" /> Tigre
      </li>
      <li nome="aranha">
        <img src="./../../../../assets/animais genericos/aranha.jpg" /> Aranha
      </li>
      <li nome="urso">
        <img src="./../../../../assets/animais genericos/urso.jpg" /> Urso
      </li>
      <li nome="sapo">
        <img src="./../../../../assets/animais genericos/sapo.jpg" /> Sapo
      </li>
      <li nome="rato">
        <img src="./../../../../assets/animais genericos/rato.jpg" /> Rato
      </li>
      <li nome="tartaruga">
        <img src="./../../../../assets/animais genericos/tartaruga.jpg" />
        Tartaruga
      </li>
      <li nome="mico">
        <img src="./../../../../assets/animais genericos/mico.jpg" /> Mico
      </li>
      <li nome="furao">
        <img src="./../../../../assets/animais genericos/furao.jpg" /> Furao
      </li>
      <li nome="chinchila">
        <img src="./../../../../assets/animais genericos/chinchila.jpg" />
        Chinchila
      </li>
      <li nome="esquilo">
        <img src="./../../../../assets/animais genericos/esquilo.jpg" /> Esquilo
      </li>
    </ul>
  </div>